<template>
  <div>
    <page-loader v-if="isLoadingTemplate" />

    <health-check-editor v-else-if="healthCheck" :healthCheck="healthCheck" @onSave="onSave" :is-saving="isSaving" />

    <v-snackbar
      v-model="snackbar.show"
      top
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.buttonColor"
          v-bind="attrs"
          text
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import PageLoader from '@/components/PageLoader';
import healthCheckTemplateApi from "@/api/healthCheckTemplate.api";
import healthCheckApi from "@/api/healthCheck.api";
import HealthCheckEditor from "@/components/HealthCheckEditor";

export default {
  components: {
    HealthCheckEditor,
    PageLoader
  },
  data() {
    return {
      showTemplateSelector: true,
      snackbar: {
        show: false,
        message: "",
        color: undefined,
        buttonColor: undefined,
        timeout: 6000,
      },
      isLoadingTemplate: false,
      healthCheck: null,
      healthCheckTemplate: null,
      isSaving: false
    };
  },
  async created() {
    try {
      this.isLoadingTemplate = true;
      this.healthCheckTemplate = await healthCheckTemplateApi.getByTemplateId(
        "5fcb3ad5-8075-4fac-9f4c-78de98ead7fc",
        1
      );
      this.createNewHealthCheckFromTemplate();
    } catch (ex) {
      this.showSnackbar("Failed to load template", true);
    } finally {
      this.isLoadingTemplate = false;
    }
  },
  methods: {
    createNewHealthCheckFromTemplate() {
      const newHealthCheck = {
        ...this.healthCheckTemplate,
        templateVersion: this.healthCheckTemplate.version,
        templateName: this.healthCheckTemplate.name,
        createdDateUtc: null,
        lastModifiedDateUtc: null,
        comments: null,
        companyName: null,
        contactEmailAddress: null,
        allowContact: false,
      };

      newHealthCheck.groups = newHealthCheck.groups.map((group) => {
        const newGroup = { ...group };
        newGroup.items = newGroup.items.map((item) => {
          return { ...item, result: undefined, comments: undefined };
        });
        return newGroup;
      });

      this.healthCheck = newHealthCheck;
    },
    onTemplateSelect() {
      this.showTemplateSelector = false;
      this.healthCheck = this.createNewHealthCheckFromTemplate();
    },
    showSnackbar(message, isError) {
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = isError ? "red accent-2" : undefined;
      this.snackbar.timeout = isError ? 0 : 6000;
    },
    async onSave(newHealthCheck) {
      this.isSaving = true;

      try {
        const result = await healthCheckApi.createHealthCheck(newHealthCheck);
        console.log(result);
        this.$router.push({ name: "report", params: { id: result.id } });
      } catch (ex) {
        this.showSnackbar("Failed to save");
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style>
</style>